import React, { useMemo } from 'react';
import GenericTableFilter from '../../../../components/common/GenericTableFilter';

const AnnouncementFilters = ({
    filterFields,
    columns,
    customFilterTypes,
    customFilterOptions,
    handleSearch,
    handleApplyFilters,
    handleResetFilters
}) => {
    const initialFilters = useMemo(() => {
        const filters = {};
        if (filterFields && filterFields.length > 0) {
            filterFields.forEach(field => {
                if (field.field === 'isActive') {
                    filters[field.field] = true;
                } else {
                    filters[field.field] = '';
                }
            });
        }
        return filters;
    }, [filterFields]);

    return (
        
            <GenericTableFilter 
                filterFields={filterFields}
                columns={columns} 
                initialFilters={initialFilters} 
                onSearch={handleSearch} 
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
                customFilterTypes={customFilterTypes}
                customFilterOptions={customFilterOptions}
            />
       
    );
};

export default AnnouncementFilters;
